import type {
	AnalyticsWebClient,
	InitAttrs,
} from '@jira/platform__observability-product-analytics-web-client-types';
import { mockAnalyticsWebClient } from './mockAnalyticsWebClient.tsx';

export const initServerAnalyticsWebClient = (_attrs?: InitAttrs): Promise<AnalyticsWebClient> =>
	Promise.resolve(mockAnalyticsWebClient);
